import { CommonModule } from '@angular/common';
import { Component, inject, model } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, } from '@angular/material/dialog';

export interface DialogData {
  event: string;
  complaintId: number;
  message: string;
  title: string;
}

@Component({
  selector: 'app-popup-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './popup-dialog.component.html',
  styleUrl: './popup-dialog.component.scss'
})
export class PopupDialogComponent {

  readonly dialogRef = inject(MatDialogRef<PopupDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly event = model(this.data.event);
  readonly title = model(this.data.title);
  readonly message = model(this.data.message);

  onNoClick(): void {
    this.dialogRef.close();
  }
}
